import { autoinject } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { AsyncErrorHandler } from 'lib/ui';
import { PenOfferDto } from 'models/pen/PenOffers';
import { PenOfferService } from 'services/pen/pen-offer-service';
import { ToastService } from 'services/toast-service';

@autoinject
export class PenOfferEdit {
  private penOffer: PenOfferDto = new PenOfferDto();

  constructor(private penOfferService: PenOfferService, private toastService: ToastService, private router: Router) {}

  private async activate(params: { Id: number; PenId: number }) {
    await this.getPenOffer(params.Id);
  }

  private async getPenOffer(id: number) {
    const response = await this.penOfferService.getOffer(id);
    this.penOffer = response.data;
  }

  private async validateBeforeSave() {
    await this.savePenOffer();
  }

  @AsyncErrorHandler
  async savePenOffer() {
    await this.penOfferService.updateOffer(this.penOffer.Id, this.penOffer);
    this.toastService.showSuccess('general.updated');
    this.router.navigateToRoute('pen-offer-view', { penOfferId: this.penOffer.Id, penId: this.penOffer.PenId });
  }
}
